export default "__VITE_ASSET__CwvxwMM0__"